
class PaymentController {
    /*@ngInject*/
    constructor($mdDialog, $stateParams, $state, orderStore, $compile, $rootScope, $sce, $timeout, utils, $q, auth, $window) {
        "ngInject";
        _.extend(this, {
        	name: 'payment',
            $stateParams: $stateParams,
            $state: $state,
            orderStore: orderStore,
            $compile: $compile,
            $rootScope: $rootScope,
            $sce: $sce,
            $timeout: $timeout,
            utils: utils,
            auth: auth,
            $q: $q,
            $mdDialog: $mdDialog,
            $window: $window
        });

        this.bill = {};
        this.customer = this.auth.currentUser();
        this.couponStatus = undefined;
        this.couponCode = "";
        this.invalidCoupon = false;
        this.availLocalDamageCover = false;
        this.localDamageCover = 0;
        this.payment_amount = 0;

        this.showPaymentSuccessMessage = this.utils.getURLParameterByName('status') === 'success' ? true : false;
        this.showPaymentFailureMessage = this.utils.getURLParameterByName('status') === 'failure' ? true : false;

        this.paymentRecordId = this.utils.getURLParameterByName('payment_record_id');

        this.orderLoader = this.orderStore.getOrderWithBill($stateParams.orderId)
            .then(
                (orderAndBill) => {
                    this.order = orderAndBill.order;
                    this.dues = this.formatDues(orderAndBill.bill.result.dues);
                    this.formattedMoveDate = moment(this.order.order_time * 1000).format('DD MMMM YYYY');
                    this.setBill(orderAndBill.bill.result.dues);
                    this.localDamageCover = orderAndBill.bill.result.damage_cover_amount ? orderAndBill.bill.result.damage_cover_amount : false;
                    this.tokenAmount = orderAndBill.bill.result.token_amount ? orderAndBill.bill.result.token_amount : false;
                    if(this.paymentRecordId) {
                        this.orderLoader = this.orderStore.getPaymentRecord($stateParams.orderId, this.paymentRecordId)
                            .then(
                                (paymentRecord) => {
                                    this.payment_amount = paymentRecord.result.amount;
                                },
                                (error) => {
                                    this.payment_amount = 0;
                                }
                            )
                    }

                    this.payment_in_progress = orderAndBill.bill.result.payment_in_progress;
                    this.time_of_payment_creation = new moment(orderAndBill.bill.result.time_of_payment_creation);
                    this.max_payment_duration_ms = orderAndBill.bill.result.max_payment_duration_ms;
                },
                (error) => this.$q.reject(error)
            );
    }

    updateDues() {
        this.orderLoader = this.orderStore.getBillForOrder(this.$stateParams.orderId, this.couponCode)
            .then(
            (bill) => {
                this.dues = this.formatDues(bill.result.dues);
                this.setBill(bill.result.dues);

                this.localDamageCover = bill.result.damage_cover_amount ? bill.result.damage_cover_amount : false;

                this.tokenAmount = bill.result.token_amount ? bill.result.token_amount : false;

                if( _(bill.errors).findIndex((error) => { return (error === 'INVALID_COUPON_CODE')||(error === 'INVALID_ORDER_AMOUNT') }) >= 0) {
                    this.invalidCoupon = true;
                    this.couponStatus = false;
                } else {
                    this.invalidCoupon = false;
                }
            }
        );
    }

    status = {
        "done": "payment_done",
        "pending": "payment_pending"
    }

    formatDues(dues) {
        return _(dues).map((due) => {
                //token should not be displayed with tax
                if (due.description == 'booking_confirmation_fee') {
                    due.amount += due.tax;
                    due.tax = 0;
                    due.discounted_amount += due.discounted_tax;
                    due.discounted_tax = 0;
                    due.label = 'Booking Confirmation Fee';
                } else {
                    due.label = this.utils.capitalize(due.description).split('_').join(' ');
                    if(due.status == this.status.done && due.discounted_amount && due.discounted_tax) {
                        due.amount = due.discounted_amount;
                        due.tax = due.discounted_tax;
                    }
                }

                return due;
            })
            .groupBy('association_type')
            .value();
    }

    setBill(dues) {
        this.pendingDues = dues.filter((due) => due.status == this.status.pending);

        this.showDamageCoverControl = (dues.filter((due) => (due.description === 'damage_cover' && due.status === this.status.done)).length > 0) ? false : true;

        this.showTokenButton = (dues.filter((due) => (due.description === 'moving_charges' && due.status === this.status.done)).length > 0) ? false : true;
        let discountedMovingChargeDueCount = (dues.filter((due) => (due.description === 'moving_charges' && due.status === this.status.done && due.discounted_amount)).length);

        let pendingMovingChargeDueCount = (dues.filter((due) => (due.description === 'moving_charges' && due.status === this.status.pending)).length);

        this.showCouponControl = ( discountedMovingChargeDueCount > 0 ) ? false : (( pendingMovingChargeDueCount > 0) ? true : false);

        this.availLocalDamageCover = dues.filter((due) => due.description === 'damage_cover').length > 0 ? true : false;

        this.tokenExists = dues.filter((due) => due.description === 'booking_confirmation_fee').length > 0 ? true : false;

        this.bill.total_tax = _(dues).reduce((sum, due) => {  return sum + due.tax; }, 0);
        this.bill.paid_tax = _(dues).reduce((sum, due) => {  return due.status === this.status.done ? (sum + due.tax) : sum; }, 0);
        this.bill.discounted_paid_tax = _(dues).reduce((sum, due) => {  return due.status === this.status.done ? (due.discounted_tax ?  sum + due.discounted_tax : sum + due.tax) : sum; }, 0);
        this.bill.pending_tax = _(dues).reduce((sum, due) => { return due.status === this.status.pending ? (sum + due.tax) : sum; }, 0);
        this.bill.discounted_pending_tax = _(dues).reduce((sum, due) => {  return due.status === this.status.pending ? (due.discounted_tax ?  sum + due.discounted_tax : sum + due.tax) : sum; }, 0);
        this.bill.discounted_tax = _(dues).reduce((sum, due) => { return due.status === this.status.pending ? (due.discounted_tax ?  sum + due.discounted_tax : sum + due.tax) : sum; }, 0);
        this.bill.total_discounted_tax = _(dues).reduce((sum, due) => { return due.discounted_tax ?  sum + due.discounted_tax : sum + due.tax }, 0);

        this.bill.total_cost = _(dues).reduce((sum, due) => { return sum + due.amount; }, 0) + this.bill.total_tax;
        this.bill.paid_cost = _(dues).reduce((sum, due) => { return due.status === this.status.done ? (sum + due.amount) : sum; }, 0) + this.bill.paid_tax;
        this.bill.pending_cost = _(dues).reduce((sum, due) => { return due.status === this.status.pending ? (sum + due.amount) : sum; }, 0) + this.bill.pending_tax;
        this.bill.discounted_cost = _(dues).reduce((sum, due) => { return due.status === this.status.pending ? (due.discounted_amount ?  sum + due.discounted_amount : sum + due.amount) : sum; }, 0) + this.bill.discounted_tax;
        this.bill.total_discounted_cost = _(dues).reduce((sum, due) => { return due.discounted_amount ?  sum + due.discounted_amount : sum + due.amount }, 0) + this.bill.total_discounted_tax;
        if(this.showPaymentFailureMessage == true){
            woopra.track("payment-failed", {
                order_id : this.order.id,
                order_status : this.order.status
            });
        }
    }

    getUpdatedOrder(status) {
        let order = _.cloneDeep(this.order);
        order.order_time = parseInt(new Date(order.order_time * 1000).getTime() / 1000, 10);
        order.status = status;

        return order;
    }

    goToPayment() {
        this.orderLoader = this.orderStore.getPaymentForOrder(this.$stateParams.orderId, this.couponCode)
            .then(
                (payment) => {
                    if(payment.data.result === false) {
                        let paymentInProgress = _.some(payment.data.errors, function(error) { return error.type === 'PAYMENT_IN_PROGRESS' });

                        if(paymentInProgress) {
                            location.reload(true);
                        } else {
                            this.utils.showErrorPopup('Token Payment Error', 'Token Payment Error', ('Unable to make token payment ' + payment.data.errors));
                        }

                    } else {
                        this.$window.open(payment.data.redirect_url, '_self');

                        // DEPRECATED_PAYU : Implementation for PayuMoney, commented now
                        // let paymentFormTemplate = this.$compile(require('common/payments/payments.submit.html'));
                        // let paymentForm = paymentFormTemplate(_.extend(this.$rootScope.$new(), {
                        //     action: this.$sce.trustAsResourceUrl(payment.data.redirect_url),
                        //     models: payment.data.result.payment_params
                        // }));

                        // // Firefox will not allow a form to be submitted if not already present in DOM
                        // document.body.appendChild(paymentForm[0]);
                        // this.$timeout(() => {
                        //     this.orderLoader = () => paymentForm[0].submit();
                        //     });
                    }
                }
            );
    }

    goToTokenPayment() {
        this.orderLoader = this.orderStore.getTokenPaymentForOrder(this.$stateParams.orderId)
            .then(
                (payment) => {
                    if(payment.data.result === false) {
                        let paymentInProgress = _.some(payment.data.errors, function(error) { return error.type === 'PAYMENT_IN_PROGRESS' });

                        if(paymentInProgress) {
                            location.reload(true);
                        } else {
                            this.utils.showErrorPopup('Token Payment Error', 'Token Payment Error', ('Unable to make token payment ' + payment.data.errors));
                        }

                    } else {
                        this.$window.open(payment.data.redirect_url, '_self');

                        // DEPRECATED_PAYU : Implementation for PayuMoney, commented now
                        // let paymentFormTemplate = this.$compile(require('common/payments/payments.submit.html'));
                        // let paymentForm = paymentFormTemplate(_.extend(this.$rootScope.$new(), {
                        //     action: this.$sce.trustAsResourceUrl(payment.data.redirect_url),
                        //     models: payment.data.result.payment_params
                        // }));

                        // // Firefox will not allow a form to be submitted if not already present in DOM
                        // document.body.appendChild(paymentForm[0]);
                        // this.$timeout(() => {
                        //     this.orderLoader = () => paymentForm[0].submit();
                        // });
                    }
                }
            );
    }

    goToQuotes () {
        this.orderLoader = this.orderStore.saveOrder(this.getUpdatedOrder(this.orderStore.status.QUOTED))
            .then(
                (order) => {
                    let quotePage = this.utils.getQuotePageForOrderWith(order.move_type, order.property_type);
                    let nextState = this.utils.getAdminStateIfApplicable(quotePage);
                    this.$state.go(nextState, {orderId: order.id});
                }
            );
    }

    goToPayLater() {
        if(this.availLocalDamageCover) {
            this.utils.showAlertPopup('You have selected damage cover!', 'Warning', 'Damage Cover is applicable only for online payments!');
        } else {
            this.order.pay_later = true;
            this.orderLoader = this.orderStore.saveOrder(this.order)
                .then(
                    (order) => {
                        let nextState = this.utils.getAdminStateIfApplicable('base.paylater');
                        this.$state.go(nextState, {orderId: order.id});
                    }
                );
        }
    }

    updateDamageCover() {
        this.orderLoader = this.orderStore.updateDamageCover(this.order.id, !this.availLocalDamageCover)
            .then(
            (response) => this.updateDues(),
            (error) => this.utils.showErrorPopup('Unable to set damage cover', 'Unable to set damage cover', 'Unable to set damage cover')
        );
    }

    applyCoupon() {
        this.appliedCouponCode = this.couponCode;
        this.showCouponEntryField = false;
        if (this.couponCode.length !== 0) {
            this.couponStatus = true;
        } else {
            this.couponStatus = false;
        }
        this.updateDues();
    }

    damageCoverPopup() {

        var popupController = function popupController($scope, $mdDialog) {
            $scope.ok = function() {
                $mdDialog.hide();
            }
        }

        this.$mdDialog.show({
        controller: popupController,
        template: require('common/popup.component/damageCoverT&C.popup.html'),
        parent: angular.element(document.body),
        clickOutsideToClose: true
        });

        popupController.$inject = ['$scope', '$mdDialog']; //to enable proper dependency injection during js minification

    }
    // cancellationLocalPopup() {
    //
    //     var popupController = function popupController($scope, $mdDialog) {
    //         $scope.ok = function() {
    //             $mdDialog.hide();
    //         }
    //     }
    //
    //     this.$mdDialog.show({
    //         controller: popupController,
    //         template: require('common/popup.component/Cancellation-local.popup.html'),
    //         parent: angular.element(document.body),
    //         clickOutsideToClose: true
    //     });
    //
    //     popupController.$inject = ['$scope', '$mdDialog']; //to enable proper dependency injection during js minification
    //
    // }
}

export default PaymentController;


// WEBPACK FOOTER //
// ./client/app/components/payment/payment.controller.js